// Shared by useStockData.js and chart.jsx (chartMain) -- both used to do
// their own single-level, non-defensive `data?.data` unwrap of the
// /stocks_charts response, which is what caused the original sparkline
// flicker bug when the real API shape drifted from the assumed one.
// StockChart.jsx's own 3-level fallback chain was already correct; this is
// that same chain, extracted once so it's shared and unit-testable instead
// of duplicated inline in two places.
export const unwrapChartResponse = (data) => {
  if (Array.isArray(data?.data?.data)) return data.data.data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data)) return data;
  return [];
};
